import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function CostStructureAnalysis({ costStructureAnalysis = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState([]);

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "cost_category", label: "Cost Category" },
        { key: "pct_of_revenue", label: "% of Revenue" },
        { key: "annual_amount", label: "Annual Amount" },
        { key: "volatility_risk", label: "Volatility Risk" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "cost_category", label: "Cost Category" },
        { key: "pct_of_revenue", label: "% of Revenue" },
        { key: "annual_amount", label: "Annual Amount" },
        { key: "key_drivers", label: "Key Drivers" },
        { key: "benchmarking_vs_industry", label: "Benchmark vs industry" },
        { key: "volatility_risk", label: "Volatility Risk" },
        {
          key: "cost_reduction_opportunities",
          label: "Cost Reduction Opportunities",
        },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  // const dummyData = [
  //   {
  //     cost_category: {
  //       value: "Raw Materials",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.9,
  //       reasoning: "Largest contributor to production costs.",
  //     },
  //     cost_category_positive_insight: {
  //       value: "Stable sourcing contracts reduce volatility.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Based on supplier agreements.",
  //     },
  //     cost_category_negative_insight: {
  //       value: "Exposed to commodity price fluctuations.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.7,
  //       reasoning: "Market price trend analysis.",
  //     },
  //     cost_category_recent_development: {
  //       value: "Secured long-term supplier agreement in July.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.8,
  //       reasoning: "Procurement announcement.",
  //     },

  //     percent_revenue: {
  //       value: "35%",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.95,
  //       reasoning: "Audited financial statements.",
  //     },
  //     percent_revenue_positive_insight: {
  //       value: "Consistent with industry benchmarks.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.9,
  //       reasoning: "Peer company cost comparison.",
  //     },
  //     percent_revenue_negative_insight: {
  //       value: "Slight increase in last quarter.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.75,
  //       reasoning: "Quarterly report analysis.",
  //     },
  //     percent_revenue_recent_development: {
  //       value: "Reduction expected due to efficiency programs.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.85,
  //       reasoning: "Internal cost optimization plan.",
  //     },

  //     annual_amount: {
  //       value: "$500M",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.95,
  //       reasoning: "Audited P&L statements.",
  //     },
  //     annual_amount_positive_insight: {
  //       value: "Projected decrease by 5% next year.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.85,
  //       reasoning: "Forecasting model outputs.",
  //     },
  //     annual_amount_negative_insight: {
  //       value: "Unexpected spike in Q2 due to supply chain issues.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.7,
  //       reasoning: "Quarterly variance analysis.",
  //     },
  //     annual_amount_recent_development: {
  //       value: "Stabilized in July after disruptions.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.8,
  //       reasoning: "Post-disruption recovery reports.",
  //     },

  //     key_drivers: {
  //       value: "Commodity Prices, Supplier Contracts",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Cost analysis breakdown.",
  //     },
  //     key_drivers_positive_insight: {
  //       value: "Strong supplier relationships mitigate risks.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.9,
  //       reasoning: "Supplier dependency mapping.",
  //     },
  //     key_drivers_negative_insight: {
  //       value: "Heavy reliance on imports.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.7,
  //       reasoning: "Sourcing risk assessment.",
  //     },
  //     key_drivers_recent_development: {
  //       value: "New local suppliers added.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.8,
  //       reasoning: "Procurement diversification efforts.",
  //     },

  //     optimization_potential: {
  //       value: "Moderate",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.8,
  //       reasoning: "Identified in internal cost review.",
  //     },
  //     optimization_potential_positive_insight: {
  //       value: "Automation initiatives underway.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.85,
  //       reasoning: "Ongoing CAPEX investments.",
  //     },
  //     optimization_potential_negative_insight: {
  //       value: "Legacy systems slow efficiency gains.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.65,
  //       reasoning: "IT infrastructure assessment.",
  //     },
  //     optimization_potential_recent_development: {
  //       value: "Lean program launched in July.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Qualitative",
  //       confidence_score: 0.8,
  //       reasoning: "Internal memo.",
  //     },

  //     investment_required: {
  //       value: "$50M",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.9,
  //       reasoning: "Budget allocation reports.",
  //     },
  //     investment_required_positive_insight: {
  //       value: "Expected ROI within 2 years.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.85,
  //       reasoning: "Financial modeling.",
  //     },
  //     investment_required_negative_insight: {
  //       value: "High upfront capital requirement.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.7,
  //       reasoning: "CAPEX allocation review.",
  //     },
  //     investment_required_recent_development: {
  //       value: "Funding approved in July board meeting.",
  //       source: "https://placeholder.source.com",
  //       data_type: "Quantitative",
  //       confidence_score: 0.8,
  //       reasoning: "Board meeting minutes.",
  //     },
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(
      costStructureAnalysis
    );
    setTabData(transformed);
    setTableBelowDescription(
      <ParsedTextWithLinks
        text={costStructureAnalysis?.[0]?.response?.tableComments || ""}
      />
    );
  }, [costStructureAnalysis]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Cost Structure Analysis"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="cost_category"
      belowTableDescription={tableBelowDescription}
      actions={actions}
    />
  );
}

export default CostStructureAnalysis;
